import { IconButton, Typography, Divider } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRTL } from "hooks/isRTL";
import ActiveDriversLocation from "./ActiveDriversLocation";
import locationMarkerIcon from "assets/icons/location-marker.svg";

import MapFallBack from "Components/shared/MapFallBack";
import {
  HeaderRow,
  MapContainer,
  PageContainer,
  SidebarBox,
} from "./DriversMapLocations.styles";
import { getActiveDrivers } from "services/driverService";
import GenericMapWithMarkers from "Components/shared/GenericMapWithMarkers";

const DriversMapLocations = () => {
  const { t } = useRTL();
  const navigate = useNavigate();
  const [drivers, setDrivers] = useState([]);
  const [currentDriver, setCurrentDriver] = useState(null);
  const [loading, setLoading] = useState(true);

  const mapRef = useRef(null);

  const handleMapLoad = (map) => {
    mapRef.current = map;
  };

  const panToDriver = (driver) => {
    if (mapRef.current && driver?.location) {
      mapRef.current.panTo(driver.location);
      setCurrentDriver(driver);
    }
  };

  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const response = await getActiveDrivers();
        const transformed = response.map((driver) => ({
          id: driver.id,
          driverId: driver.driverId,
          name: driver.fullName,
          activeTime: new Date().toLocaleString(),
          phoneNumber: driver.phoneNumber,
          location: {
            lat: driver.coordinates.latitude,
            lng: driver.coordinates.longitude,
          },
        }));
        setDrivers(transformed);
        setCurrentDriver(transformed[0] || null);
      } catch (err) {
        console.error("Failed to fetch drivers", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDrivers();
  }, []);

  return (
    <PageContainer>
      <SidebarBox>
        <HeaderRow>
          <IconButton onClick={() => navigate(-1)} sx={{ padding: 0 }}>
            <ArrowBack fontSize="medium" />
          </IconButton>
          <Typography variant="h2" fontWeight="bold" color="text.primary">
            {t("activeDrivers")}
          </Typography>
        </HeaderRow>

        <Divider />

        <ActiveDriversLocation
          drivers={drivers}
          currentDriver={currentDriver}
          setCurrentDriver={setCurrentDriver}
          panToDriver={panToDriver}
          loading={loading}
        />
      </SidebarBox>

      <MapContainer>
        {loading ? (
          <></>
        ) : drivers.length === 0 ? (
          <MapFallBack />
        ) : (
          <GenericMapWithMarkers
            markers={
              currentDriver
                ? [
                    {
                      position: currentDriver.location,
                      icon: locationMarkerIcon,
                    },
                  ]
                : []
            }
            center={currentDriver?.location}
            onMapLoad={handleMapLoad}
          />
        )}
      </MapContainer>
    </PageContainer>
  );
};

export default DriversMapLocations;
